import * as React from 'react';
import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

import SideNav from './SideNav';

type Props = Readonly<{
  children: React.ReactNode;
}>;

export default function Layout({ children }: Props) {
  return (
    <html.div style={styles.wrap}>
      <SideNav />
      <html.div style={styles.content}>{children}</html.div>
    </html.div>
  );
}

const styles = css.create({
  wrap: {
    minHeight: '100vh',
    backgroundColor: '#fafafa',
    color: color.neutral100,
    display: 'flex',
  },
  content: {
    // same as SIDE_NAV_WIDTH
    marginLeft: {
      default: 200,
      '@media (max-width: 768px)': 0,
    },
    paddingTop: {
      default: 0,
      // clear the fixed mobile header
      '@media (max-width: 768px)': 56,
    },
    flex: 1,
    // allow the flex child to shrink instead of overflowing the viewport
    minWidth: 0,
    transition: 'margin-left 0.25s',
  },
});
